export default "<app-user-form (onsubmit)=\"save($event)\"></app-user-form>";